export default 'https://tme.understood.org/assets/rails.f5159007.glb'